var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16648_139002)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88344 58.4676C6.526 58.4676 5.16855 57.9019 4.15046 56.8836L1.66181 54.3944C0.643728 53.3762 0.078125 52.0184 0.078125 50.6607C0.078125 49.1899 0.643728 47.8322 1.66181 46.8139L32.5437 15.926L32.6568 15.8129C32.77 15.8129 32.8831 15.6997 32.9962 15.6997H33.3356C33.4487 15.8129 33.4487 15.8129 33.5618 15.8129C35.0324 16.8312 36.9554 16.718 38.1997 15.5866C38.5391 15.2472 39.1047 15.2472 39.331 15.5866L42.9508 19.2072C43.2902 19.4334 43.2902 19.9992 42.9508 20.3386C41.8196 21.5831 41.7065 23.5066 42.7246 24.9774C42.7246 25.0906 42.7246 25.0906 42.8377 25.2037V25.5431C42.8377 25.6563 42.8377 25.7694 42.7246 25.8826L42.6115 25.9957L11.7295 56.8836C10.7115 57.9019 9.35401 58.4676 7.88344 58.4676Z",
    fill: "url(#paint0_radial_16648_139002)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7812 14.0039L53.1295 0.766289C53.4688 0.426862 53.9213 0.426862 54.2607 0.766289L57.7674 4.2737C58.1068 4.61313 58.1068 5.0657 57.7674 5.40513L44.5323 18.7559C44.4192 18.5296 44.193 18.3034 44.0798 18.0771L40.46 14.4565C40.2337 14.3434 40.0075 14.1171 39.7812 14.0039Z",
    fill: "url(#paint1_radial_16648_139002)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16648_139002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.642 36.8998) scale(18.6742 26.4155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16648_139002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9017 9.63382) scale(7.89825 11.1725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16648_139002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.9233,
    height: 57.9233,
    fill: "white",
    transform: "translate(0.078125 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatIcon);
export default __webpack_public_path__ + "static/media/batIcon.7aeaf3da17a995c6201d655fe67c1767.svg";
export { ForwardRef as ReactComponent };